function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgZutoLogoMediuminline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 148.99 53.47",
  height: 30
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M124.99 1.6c-.94-.94-2.67-1.6-3.88-1.6H2.27C1.07 0 0 .94 0 2.27v49.06c0 1.07 1.07 2.14 2.27 2.14h118.85c1.2 0 2.94-.67 3.74-1.6l23.53-23.53c.8-.8.8-2.27 0-3.21L124.99 1.6Z",
  style: {
    fill: "#6b676f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.1 36.23 14.3-17.11H10.96V9.09h29.28v8.15L26.07 34.35h14.97v10.03H11.1v-8.15Zm34.09-19.79h10.96v18.58c0 1.34.53 2.27 2.01 2.27 1.2 0 2.27-.8 3.34-2.01V16.44h10.96v27.94H62.17l-.67-2.94c-1.74 1.87-4.68 3.61-7.75 3.61-6.28 0-8.56-3.48-8.56-10.29V16.44Zm42.24-7.35H76.6v25.27c0 7.35 2.81 10.56 9.49 10.56 5.21 0 9.63-2.94 9.63-2.94l-3.21-6.55s-2.01.94-3.21.94-1.87-.67-1.87-2.27V23.54h6.55v-7.09h-6.55V9.1Zm23.66 28.21c2.41 0 3.61-2.67 3.61-6.95 0-4.01-1.2-6.68-3.61-6.68s-3.61 2.67-3.61 6.68c-.13 4.28 1.07 6.95 3.61 6.95Zm14.57-7.09c0-8.56-6.28-14.44-14.57-14.44s-14.71 5.88-14.57 14.44c0 9.22 5.88 14.84 14.57 14.84s14.57-5.75 14.57-14.84Z",
  style: {
    fill: "#ffed00",
    fillRule: "evenodd"
  }
}));
export default SvgZutoLogoMediuminline;